import { TraitId, TraitStatus } from '@cibo/core'
import { FriendlyError } from '@cibo/ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { NavButtons as TraitTableNavButtons, useRollupQuestion } from '@cibo/landmanager'

export interface AddInformationNavButtonsProps {
  traitStatuses?: TraitStatus[]
  focusTraitId: TraitId
  setFocusTraitId(traitId: TraitId): void
  onFinishLater?: () => void
  onContinue?: () => void
}

export const AddInformationNavButtons = ({
  traitStatuses,
  focusTraitId,
  setFocusTraitId,
  onContinue,
  onFinishLater,
}: AddInformationNavButtonsProps) => {
  const { t } = useTranslation('AddInformation')
  const { rollupRequested, commitChanges } = useRollupQuestion()
  const [isUpdating, setIsUpdating] = useState(false)
  const [commitError, setCommitError] = useState<any | undefined>()
  const navigate = useNavigate()

  const statuses = traitStatuses

  const currentIndex = statuses?.findIndex(
    (item: { traitId: TraitId }) => item.traitId === focusTraitId
  )

  const handleClickExit = () => {
    !!onFinishLater ? onFinishLater() : navigate(-1)
  }

  const stepNav = async (direction: number) => {
    if (!statuses || currentIndex === undefined) {
      return
    }

    if (rollupRequested) {
      setIsUpdating(true)
      try {
        await commitChanges()
        setIsUpdating(false)
      } catch (error) {
        setIsUpdating(false)
        setCommitError(error)
        return
      }
    }

    const nextTrait = statuses[currentIndex + direction]
    if (nextTrait) {
      setFocusTraitId(nextTrait.traitId)
    } else {
      !!onContinue ? onContinue() : navigate(-1)
    }
  }

  const handleClickContinue = () => {
    stepNav(1)
  }
  const handleClickPrevious = () => {
    stepNav(-1)
  }

  const canContinue =
    // user can continue if they've filled in all the statuses
    !traitStatuses?.find(a => a.traitId === focusTraitId)?.missing ||
    // or if they've set the rollup value so that they don't have to fill them in
    !!rollupRequested

  return (
    <>
      {!!commitError && <FriendlyError message={t('commitError')} />}
      <TraitTableNavButtons
        canContinue={canContinue}
        canGoPrevious={!!currentIndex && currentIndex > 0}
        isUpdating={isUpdating}
        onClickExit={handleClickExit}
        onClickContinue={handleClickContinue}
        onClickPrevious={handleClickPrevious}
      />
    </>
  )
}
